import { Box, Paper, Divider } from "@mui/material";
import CelleraLogo from "components/common/CelleraLogo";
import { EPath } from "constants/path";
import { useToast } from "contexts/ToastContext";
import { GoogleSignInRequestUserTypeEnum } from "libs/cellera-sdk";
import { useState } from "react";

import GoogleSignIn from "../components/features/auth/GoogleSignIn";
import LoginEmailPasswordForm from "../components/features/auth/LoginEmailPasswordForm";
import { AuthResult } from "../types";

export default function LoginPage() {
  const [rememberMe, setRememberMe] = useState(false);
  const { showError } = useToast();

  const handleAuthSuccess: (result: AuthResult) => void = (result) => {
    if (
      "requiresEmailVerification" in result &&
      result.requiresEmailVerification
    ) {
      // Handle email verification required case
      return;
    }
    if ("requiresOnboarding" in result && result.requiresOnboarding) {
      // Handle onboarding required case
      window.location.href = EPath.ONBOARDING;
      return;
    } else {
      window.location.href = EPath.PROVIDER_DASHBOARD;
    }
  };

  const handleAuthError = (error: Error) => {
    // Handle authentication error
    showError("Authentication failed", error.message);
  };

  return (
    <Box className="h-screen bg-color_F8F8F8 flex items-center justify-center p-4">
      <Paper
        elevation={1}
        className="w-full max-w-xl p-16 rounded-xl shadow-lg"
        sx={{
          backgroundColor: "white",
          borderRadius: "12px",
        }}
      >
        {/* Logo */}
        <Box className="text-center flex items-center justify-center mb-8">
          <CelleraLogo />
        </Box>

        {/* Login with Email and Password form */}
        <LoginEmailPasswordForm
          userType={GoogleSignInRequestUserTypeEnum.Provider}
          onSuccess={handleAuthSuccess}
          onError={handleAuthError}
          rememberMe={rememberMe}
          setRememberMe={setRememberMe}
        />

        {/* Divider */}
        <Divider className="my-6" />

        {/* Google Sign In */}
        <GoogleSignIn
          userType={GoogleSignInRequestUserTypeEnum.Provider}
          onSuccess={handleAuthSuccess}
          onError={handleAuthError}
          rememberMe={rememberMe}
        />
      </Paper>
    </Box>
  );
}
